import Sentry from "@similarweb/sentry-logger";

import { US_COUNTRY_ID } from "app/services/countryServiceConst";
import { DefaultFetchService } from "app/services/fetchService";

import type { ITopicsRawData } from "../types";

const ENDPOINT = "api/MarketResearch/DemandSearchTrends/Topics";

interface FetchDemandTopicsParams {
    country: number;
}

let cachedData: ITopicsRawData | null = null;
let fetchPromise: Promise<ITopicsRawData> | null = null;

export const fetchDemandTopics = async (country = US_COUNTRY_ID): Promise<ITopicsRawData> => {
    if (cachedData) {
        return cachedData;
    } else if (fetchPromise) {
        return fetchPromise;
    } else {
        fetchPromise = (async () => {
            try {
                const fetchService = DefaultFetchService.getInstance();
                const queryParams: FetchDemandTopicsParams = { country };
                const rawData = await fetchService.get<ITopicsRawData>(ENDPOINT, queryParams);
                cachedData = rawData;
                return rawData;
            } catch (error) {
                Sentry.error("Failed to fetch demand topics:", error);
                throw error;
            } finally {
                fetchPromise = null;
            }
        })();

        return fetchPromise;
    }
};
